import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0a29a40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = {
  target: "_blank",
  rel: "noopener noreferrer",
  href: "https://moment.github.io/luxon/#/formatting?id=table-of-tokens"
}
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_DxpOmsInstanceNavigator = _resolveComponent("DxpOmsInstanceNavigator")!
  const _component_DxpProductStoreSelector = _resolveComponent("DxpProductStoreSelector")!
  const _component_DxpAppVersionInfo = _resolveComponent("DxpAppVersionInfo")!
  const _component_DxpProductIdentifier = _resolveComponent("DxpProductIdentifier")!
  const _component_DxpTimeZoneSwitcher = _resolveComponent("DxpTimeZoneSwitcher")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, { slot: "start" }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Settings")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, { lines: "full" }, {
                  default: _withCtx(() => [
                    (_ctx.userProfile?.partyImageUrl)
                      ? (_openBlock(), _createBlock(_component_ion_avatar, {
                          key: 0,
                          slot: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Image, {
                              src: _ctx.userProfile.partyImageUrl
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_card_header, { class: "ion-no-padding ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile?.userLoginId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile?.partyName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  color: "danger",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Logout")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  "standalone-hidden": !_ctx.hasPermission(_ctx.Actions.APP_PWA_STANDALONE_ACCESS),
                  fill: "outline",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLaunchpad()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Go to Launchpad")) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.openOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["standalone-hidden"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.translate('OMS')), 1)
          ]),
          _createElementVNode("section", null, [
            _createVNode(_component_DxpOmsInstanceNavigator),
            _createVNode(_component_DxpProductStoreSelector, { onUpdateEComStore: _ctx.updateEComStore }, null, 8, ["onUpdateEComStore"])
          ]),
          _hoisted_3,
          _createVNode(_component_DxpAppVersionInfo),
          _createElementVNode("section", null, [
            _createVNode(_component_DxpProductIdentifier),
            _createVNode(_component_DxpTimeZoneSwitcher, { onTimeZoneUpdated: _ctx.timeZoneUpdated }, null, 8, ["onTimeZoneUpdated"]),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("File upload")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Date Format")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate('Enter a custom date time format that you want to use when uploading documents to HotWax Commerce.')) + " ", 1),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.translate('Luxon date time formats can be found')) + " ", 1),
                      _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.translate("here")), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      "clear-input": true,
                      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => {_ctx.dateTimeFormat = $event.target.value; _ctx.parseSampleDateTime()}, ["enter"])),
                      modelValue: _ctx.dateTimeFormat,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateTimeFormat) = $event)),
                      value: _ctx.dateTimeFormat,
                      placeholder: _ctx.defaultDateTimeFormat
                    }, null, 8, ["modelValue", "value", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.sampleDateTime), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_badge, { color: "warning" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Sample")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateDateTimeFormat()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Save")) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.saveOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Product Upload Identifier")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Choosing an identifier to map products by when uploading documents. If not explicitly specified Import will default to the identifier used during product import from Shopify.")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_toggle, {
                      disabled: !_ctx.currentEComStore.productIdentifierEnumId || _ctx.productSelectorPref,
                      checked: _ctx.isDefaultProductStoreIdentifierSelected && !!_ctx.currentEComStore.productIdentifierEnumId,
                      onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleProductStoreEnumId($event.detail.checked)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Use default identifier")) + " ", 1),
                            (_ctx.currentEComStore.productIdentifierEnumId)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.translate("Currently set to", { productIdentifierEnumId: _ctx.getIdentificationDesp(_ctx.currentEComStore.productIdentifierEnumId) })), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled", "checked"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      label: _ctx.translate('Upload Identifier'),
                      interface: "popover",
                      placeholder: _ctx.translate('Select'),
                      value: _ctx.productSelectorPref,
                      onIonChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateProductSelectorPref($event)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodIdentificationTypes, (identification) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: identification.goodIdentificationTypeId,
                            value: identification.goodIdentificationTypeId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(identification.description ? identification.description : identification.goodIdentificationTypeId), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["label", "placeholder", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}